import React from 'react';
import cx from 'classnames';

import { SortIcon } from '@trqk/components';

interface DetectionTrackColumn extends SortableColumn<DetectionTrack> {
    enabledCountAll: number;
    enabledCountNonDraftOnly: number;
}

interface Props {
    column: DetectionTrackColumn;
}

export const DetectionsEnabledHeader = ({ column }: Props): JSX.Element => {
    const {
        isSorted,
        isSortedDesc,
        enabledCountAll,
        enabledCountNonDraftOnly,
    } = column;

    const label =
        enabledCountNonDraftOnly === enabledCountAll
            ? `Enabled (${enabledCountAll})`
            : `Enabled (${enabledCountAll}*)`;

    const headerClasses = cx('w-full h-full font-semibold text-xs px-1', {
        'text-black': isSorted,
    });

    return (
        <div className={headerClasses}>
            <div className="w-full h-full mb-1">
                <div className={cx({ underline: isSorted })}>
                    <span className="pr-1">{label}</span>
                    <SortIcon isSorted={isSorted} isSortedDesc={isSortedDesc} />
                </div>
            </div>
        </div>
    );
};
